import { useEffect, useRef } from "react";

// Ejecuta "refrescar" cada "intervaloMs" mientras la pestaña está visible, y
// también al volver a la pestaña. Así las tablas muestran lo que registran
// otros usuarios sin tener que recargar la página.
const useAutoRefresco = (refrescar, intervaloMs = 30000) => {
  // se guarda la última versión de la función para no reiniciar el intervalo
  // cada vez que cambian los filtros
  const refrescarRef = useRef(refrescar);
  refrescarRef.current = refrescar;

  useEffect(() => {
    const ejecutarSiVisible = () => {
      if (document.visibilityState === "visible") refrescarRef.current();
    };

    const intervalo = setInterval(ejecutarSiVisible, intervaloMs);
    document.addEventListener("visibilitychange", ejecutarSiVisible);

    return () => {
      clearInterval(intervalo);
      document.removeEventListener("visibilitychange", ejecutarSiVisible);
    };
  }, [intervaloMs]);
};

export default useAutoRefresco;
